var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',{attrs:{"hide-breadcrumbs":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('PageTitle',[_vm._v(" Best Athletes Dashboard ")])]},proxy:true}])},[_c('v-card',[_c('v-card-title',[_vm._v("Best Athletes")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }